import Vue from 'vue';
import DataTable from 'laravel-vue-datatable';
import DropdownDatepicker from 'vue-dropdown-datepicker';
import jsQR from 'jsqr';
import 'livewire-vue';

require('./bootstrap');
import tippy from 'tippy.js';

window.Vue = Vue
Vue.use(DataTable);
//Vue.use(DropdownDatepicker);

require('livewire-sortable');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

jQuery(document).ready(() => {

    //hamburger
    $('#hamburger').click(function() {
        $(this).toggleClass('is-active');
        $('#container').toggleClass('active-nav');
        $('#nav').toggleClass('active');
    });

    //decline invites
    $('.decline-invite').on('click', function () {
        return confirm('Are you sure?  You will lose your spot in this wave.');
    });

    //CRUD generalized delete button
    $('.delete-button').click(function(e) {
        e.preventDefault();
        if (confirm('Are you sure you want to delete this?')) {
            $('#delete-form').submit();
        }
    });

    //toggle cards
    $('.toggle-btn').click(function(e) {
        $(this).toggleClass('btn-orange');
        let target = $(this).attr('data-target');
        $('#'+target).toggle();
    });

    //waivers
    //youth waiver
    $('#youth-waiver-accept').click(function() {
        $('#youth-waiver-2').show();
        $('#youth-waiver-1').hide();
        $(window).scrollTop(0);
    });
    //covid waiver
    $('#covid-waiver-form').submit(function(e) {
        e.preventDefault();
        $('#main-waiver').show();
        $('#covid-waiver').hide();
        $(window).scrollTop(0);
    });

    //gift checkbox
    if ($('#gift_checkbox').length) {
        let gift_checkbox = $('#gift_checkbox');
        let gift_row = $('#gift-handler-row');

        if (gift_checkbox.prop('checked')) { gift_row.show(); }

        gift_checkbox.on('change', function() {
            $(this).prop('checked') ? gift_row.show() : gift_row.hide();
        });
    }

    //tippy
    initTippy();
    Livewire.on('waveChanged', waveId => {
        setTimeout(function(){  initTippy(); }, 1000);
    });

    //payment more button
    $('.payment-more-trigger').click(function(e) {
        e.preventDefault();
        let $txt = $(this).text() == 'More' ? 'Less' : 'More';
        $(this).text($txt);
        $(this).next().slideToggle();
    });

    //
    $('.toggle-registrations').click(function() {
        $(this).parent().find('.waves').slideToggle();

        let $txt = $(this).find('span').text() == 'Show' ? 'Hide' : 'Show';
        $(this).find('span').text($txt);

        $(this).toggleClass('btn-orange btn-info');
    });

    //button with feedback so it doesn't keep getting clicked
    $('.btn-feedback').click(function() {
        $(this).addClass('disabled');
        $(this).prepend('<span class="spinner-border spinner-border-sm mb-1" role="status" aria-hidden="true"></span>');
    });

    //links that scroll to top of page
    $('.scroll-top-links').on('click', 'button', function() {
        $('html, body').animate({ scrollTop: 0 }, 'fast');
    });

    //ev more jumps toggle
    $('body').on('mousedown', '.toggle-ev-previous-jumps', function(e) {
        e.preventDefault();
        let $txt = $(this).find('span').html() == 'See' ? 'Hide' : 'See';
        $(this).find('span').html($txt);
        $(this).next().slideToggle();
    });

    //toggle group stage groups listing
    $('body').on('mousedown', '.toggle-group-team-list', function(e) {
        e.preventDefault();
        $(this).find('i').toggleClass('fa-caret-up fa-caret-down');
        $(this).closest('.scoring-group').find('.css-table-wrapper').slideToggle();
    });

    //prize report year
    $('#report-select-year').change(function(e) {
        window.location = $(this).val();
    });

    //nag window for ID registration
    $('.reg-checkbox-7 input').click(function() {
        if ($(this).is(':checked')) {
            confirm('Iron Dog fee is nonrefundable. Please ensure that you\'ve signed up for waves under each discipline.');
        }
    });


    //QR code capturing for live event registration
    if ($('#capture').length) {
        let video = document.createElement("video");
        let canvasElement = document.getElementById("capture");
        let canvas = canvasElement.getContext("2d");
        let loadingMessage = document.getElementById("loadingMessage");
        let capture_button = $('#capture-button');

        capture_button.hide();
        capture_button.click(function() {
            $(this).hide();
        });

        // Use facingMode: environment to attemt to get the front camera on phones
        navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then(function(stream) {
            video.srcObject = stream;
            video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
            video.play();
            requestAnimationFrame(tick);
        });

        function tick() {
            loadingMessage.innerText = "Loading video..."
            if (video.readyState === video.HAVE_ENOUGH_DATA) {
                loadingMessage.hidden = true;
                canvasElement.hidden = false;
                canvasElement.height = video.videoHeight;
                canvasElement.width = video.videoWidth;
                canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
                let imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
                let code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: "dontInvert",
                });

                if (code && code.data != '') {
                    capture_button.show();
                    capture_button.attr('href', code.data);
                }
            }
            requestAnimationFrame(tick);
        }
    }


});


function initTippy() {
    tippy(document.querySelectorAll('.tool-tip-trigger'), {
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true,
        trigger: 'click',
        theme: 'light-border',
        interactive: true,
    });
}

Livewire.on('printScoring', url => {
    window.open(url);
});

Livewire.on('openModal', id => {
    $('#'+id).modal('show');
});


const app = new Vue({
    el: '#app',
    components: {
        DropdownDatepicker
    }
});
